import {kInternalRoutes} from "./internalRoutes";

// PROPERTIES
export const kGames = [
    {
        id: 0,
        title: 'Calcul mental',
        description: 'Résouds des calculs faisables de tête sur tous les types de nombres, en mobilisant les opérations fondamentales (＋, −, ×, ÷) et leurs propriétés.',
        background: '/images/games/mentalCalculationBackground.png',
        levels: [
            {
                id: 1,
                label: 'Les tables de multiplication',
                description: 'Trouve le résultat de la multiplication entre deux nombres compris entre 0 et 10',
                grade: 'CE2',
                route: kInternalRoutes.mentalLevelOneGame
            },
        ]
    },
    {
        id: 1,
        title: 'Les nombres relatifs',
        description: 'Les nombres positifs et négatifs sont ici à l’honneur. Applique les bonnes règles de signe pour trouver le résultat.',
        background: '/images/games/relativesBackground.png',
        levels: [
            {
                id: 1,
                label: 'Addition de nombres relatifs',
                description: 'Trouve le résultat de la somme entre deux nombres relatifs compris entre -20 et +20',
                grade: '5ᵉ',
                route: kInternalRoutes.relativeLevelOneGame
            },
            {
                id: 2,
                label: 'Soustraction de nombres relatifs',
                description: 'Trouve le résultat de la différence entre deux nombres relatifs compris entre -20 et +20',
                grade: '5ᵉ',
                route: kInternalRoutes.relativeLevelTwoGame
            },
        ]
    },
];